import React, { Component } from 'react';
import { object, string } from 'prop-types';
import { inject, observer } from 'mobx-react';
import GenericError from '../../../../../client/components/modals/generic-error';

import ConnectionsList from './connections-list';

class ConnectionsContainer extends Component {
  static propTypes = {
    mailchimp: object.isRequired,
    biLogger: object.isRequired,
    view: object.isRequired,
    integrationKey: string.isRequired,
  };

  handleConnect = (srcId, dstId) => {
    const { mailchimp, biLogger, view, integrationKey } = this.props;

    biLogger.mailchimpConnectClick({
      mailChimpListId: dstId,
      wixLabelId: srcId,
    });

    !mailchimp.connectionExist(srcId, dstId) &&
      mailchimp.api
        .saveConnection(srcId, dstId)
        .then((response) => {
          if (response.added) {
            mailchimp.addConnection(response.connection);
            biLogger.mailchimpConnectSuccess({
              mailChimpListId: dstId,
              wixLabelId: srcId,
            });
          }
        })
        .catch(() => {
          view.openModal(<GenericError biData={{ integrationKey }} />);
        });
  };

  handleDelete = (connectionUID) => {
    const { mailchimp, biLogger, view, integrationKey } = this.props;

    mailchimp.api
      .deleteConnection(connectionUID)
      .then((response) => {
        biLogger.mailchimpDeleteConnection({ connectionUID });
        response.deleted && mailchimp.removeConnection(response.uid);
      })
      .catch(() => {
        view.openModal(<GenericError biData={{ integrationKey }} />);
      });
  };

  handleCreateAnotherConnection = () =>
    this.props.biLogger.mailchimpCreateAnother();

  render() {
    const {
      mailchimp: {
        connectionsArray,
        wixContactLabelsArray,
        mailChimpContactLabelsArray,
      },
    } = this.props;

    return (
      <ConnectionsList
        connections={connectionsArray}
        wixContactLabels={wixContactLabelsArray}
        mailChimpContactLabels={mailChimpContactLabelsArray}
        onConnect={this.handleConnect}
        onDelete={this.handleDelete}
        onCreateAnother={this.handleCreateAnotherConnection}
      />
    );
  }
}

export default inject(
  'mailchimp',
  'biLogger',
  'view',
)(observer(ConnectionsContainer));
